/**
 * Here is an icon config for body heading component. How it works?
 * Key - for example 'routineData' represents field in entity. If this field exists
 * and non-null value, then icon 'routine' with tooltip 'Repeatable' will be shown.
 *
 * Only one icon allowed
 * */

export const iconsMapForCmmsTableName = {
	routineData: {
		tooltip: 'recurring',
		icon: 'routine',
	},
};
